module.exports = __webpack_public_path__ + "img/landScapeTwo.c8e5cc54.jpg";